var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43852",
    "data-name": "Group 43852",
    transform: "translate(-992 -1188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4657",
    "data-name": "Ellipse 4657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pinterest",
    "data-name": "Icon awesome-pinterest",
    d: "M26,13.562A13,13,0,0,1,9.152,25.981a14.613,14.613,0,0,0,1.615-3.407c.157-.608.807-3.093.807-3.093a3.482,3.482,0,0,0,2.977,1.494c3.921,0,6.746-3.606,6.746-8.088,0-4.293-3.507-7.506-8.015-7.506-5.609,0-8.592,3.764-8.592,7.868,0,1.908,1.017,4.283,2.637,5.038.246.115.377.063.435-.173.042-.178.262-1.064.362-1.473a.389.389,0,0,0-.089-.372A5.12,5.12,0,0,1,7.077,13.3a5.626,5.626,0,0,1,5.871-5.64,5.132,5.132,0,0,1,5.431,5.289c0,3.517-1.777,5.955-4.089,5.955a1.886,1.886,0,0,1-1.924-2.348,26.122,26.122,0,0,0,1.075-4.33A1.633,1.633,0,0,0,11.794,10.4c-1.305,0-2.354,1.347-2.354,3.156a4.684,4.684,0,0,0,.388,1.929s-1.284,5.441-1.52,6.458a12.584,12.584,0,0,0-.047,3.732A13,13,0,1,1,26,13.562Z",
    transform: "translate(992 1187.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.a255177938087c96a5db0d8df1302bc4.svg";
export { ForwardRef as ReactComponent };